/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Feature_3Inputs */

const en_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a cleaner view on all results pages`)
};

const id_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan tampilan yang rapi di semua halaman hasil`)
};

const ms_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan paparan yang lebih tapi di semua halaman hasil`)
};

const ca_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtingues un aspecte més endreçat a totes les pàgines de resultats`)
};

const cs_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čištější zobrazení všech stránek s výsledky`)
};

const da_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få en renere visning på alle resultatsider`)
};

const de_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhalte eine übersichtlichere Anzeige aller Ergebnisseiten`)
};

const et_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puhtam vaade kõikidele tulemuste lehtedele`)
};

const es_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén una vista más clara en las páginas de resultados`)
};

const fr_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bénéficiez de pages de résultats améliorées`)
};

const hr_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobijte jasniji pregled na svim stranisama s rezultatima pretrage`)
};

const it_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naviga con una visuale più pulita di tutti i risultati`)
};

const lv_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iegūstiet pārskatāmākas rezultātu lapas`)
};

const lt_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaukite aiškesnį visų rezultatų puslapių vaizdą`)
};

const hu_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áttekinthetőbb találati oldalak`)
};

const nl_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strakkere weergave van resultaten`)
};

const nb_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ryddige oversikter på alle resultatsider`)
};

const pl_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bardziej przejrzysty widok na wszystkich stronach wyników`)
};

const pt_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desfrute de uma visualização mais limpa em todas as páginas de resultados`)
};

const ro_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obține o vizualizare mai clară pe toate paginile de rezultate`)
};

const sk_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prehľadnejšie zobrazenie na všetkých stránkach s výsledkami`)
};

const sl_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pridobite čistejši pogled na vseh straneh z rezultati`)
};

const fi_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanki selkeämpi näkymä kaikille tulossivuille`)
};

const sv_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få en renare syn på alla resultatsidor`)
};

const vi_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem kết quả tất cả các trang kết quả rõ ràng hơn`)
};

const tr_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm sonuç sayfalarında daha temiz bir görünüm elde edin`)
};

const el_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αποκτήστε μια πιο καθαρή προβολή σε όλες τις σελίδες αποτελεσμάτων`)
};

const bg_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получаваш по-чист преглед на всички страници с резултати`)
};

const ru_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте более чистый и удобный вид на всех страницах с результатами.`)
};

const sr_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Јаснији приказ на свим страницама са резултатима претраге`)
};

const uk_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримайте результати пошуку без реклами`)
};

const ka_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მიიღეთ უკეთესი შედეგები`)
};

const hi_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी रिजल्ट्स का साफ़ दृश्य प्राप्त करें`)
};

const th_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูผลลัพธ์ในทุกหน้าได้อย่างชัดเจนยิ่งขึ้น`)
};

const ko_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 검색 결과 페이지 깔끔하게 보기`)
};

const zh_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在所有搜索结果页面获取更干净的视图`)
};

const zh_tw_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在所有結果頁面獲得更清晰的檢視`)
};

const ja_search_feature_3 = /** @type {(inputs: Search_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索結果の全ページをすっきりと表示`)
};

/**
* | output |
* | --- |
* | "Get a cleaner view on all results pages" |
*
* @param {Search_Feature_3Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const search_feature_3 = /** @type {((inputs?: Search_Feature_3Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Feature_3Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_feature_3(inputs)
	if (locale === "ms") return ms_search_feature_3(inputs)
	if (locale === "ca") return ca_search_feature_3(inputs)
	if (locale === "cs") return cs_search_feature_3(inputs)
	if (locale === "da") return da_search_feature_3(inputs)
	if (locale === "de") return de_search_feature_3(inputs)
	if (locale === "et") return et_search_feature_3(inputs)
	if (locale === "es") return es_search_feature_3(inputs)
	if (locale === "fr") return fr_search_feature_3(inputs)
	if (locale === "hr") return hr_search_feature_3(inputs)
	if (locale === "it") return it_search_feature_3(inputs)
	if (locale === "lv") return lv_search_feature_3(inputs)
	if (locale === "lt") return lt_search_feature_3(inputs)
	if (locale === "hu") return hu_search_feature_3(inputs)
	if (locale === "nl") return nl_search_feature_3(inputs)
	if (locale === "nb") return nb_search_feature_3(inputs)
	if (locale === "pl") return pl_search_feature_3(inputs)
	if (locale === "pt") return pt_search_feature_3(inputs)
	if (locale === "ro") return ro_search_feature_3(inputs)
	if (locale === "sk") return sk_search_feature_3(inputs)
	if (locale === "sl") return sl_search_feature_3(inputs)
	if (locale === "fi") return fi_search_feature_3(inputs)
	if (locale === "sv") return sv_search_feature_3(inputs)
	if (locale === "vi") return vi_search_feature_3(inputs)
	if (locale === "tr") return tr_search_feature_3(inputs)
	if (locale === "el") return el_search_feature_3(inputs)
	if (locale === "bg") return bg_search_feature_3(inputs)
	if (locale === "ru") return ru_search_feature_3(inputs)
	if (locale === "sr") return sr_search_feature_3(inputs)
	if (locale === "uk") return uk_search_feature_3(inputs)
	if (locale === "ka") return ka_search_feature_3(inputs)
	if (locale === "hi") return hi_search_feature_3(inputs)
	if (locale === "th") return th_search_feature_3(inputs)
	if (locale === "ko") return ko_search_feature_3(inputs)
	if (locale === "zh") return zh_search_feature_3(inputs)
	if (locale === "zh-tw") return zh_tw_search_feature_3(inputs)
	if (locale === "ja") return ja_search_feature_3(inputs)
	return en_search_feature_3(inputs)
});